import { cn } from '@/utils/cn'

export interface ChatHeaderProps {
  title: string
  className?: string
}

/**
 * Chat header with title, status indicator, and ARIA live region.
 */
export function ChatHeader({
  title,
  className,
}: ChatHeaderProps) {
  return (
    <header
      className={cn(
        'flex items-center justify-between border-b border-gray-200 bg-white px-4 py-3',
        className
      )}
    >
      <div className="min-w-0 flex-1">
        <h1 className="text-lg font-semibold text-gray-900">{title}</h1>
      </div>

    </header>
  )
}
